export interface CurrencyOption {
  flag: string;
  code: string;
  symbol: string;
  perInvite: number;
  perAnniversary: number;
  plannerYearly: number;
  tablePlan: number;
  tablePlanOriginal: number;
}

export const CURRENCIES: CurrencyOption[] = [
  { flag: '🇬🇧', code: 'GBP', symbol: '£', perInvite: 39, perAnniversary: 19, plannerYearly: 199, tablePlan: 9.99,  tablePlanOriginal: 14.99 },
  { flag: '🇺🇸', code: 'USD', symbol: '$', perInvite: 49, perAnniversary: 24, plannerYearly: 249, tablePlan: 12.99, tablePlanOriginal: 18.99 },
  { flag: '🇪🇺', code: 'EUR', symbol: '€', perInvite: 46, perAnniversary: 22, plannerYearly: 229, tablePlan: 11.99, tablePlanOriginal: 17.99 },
];

export const CURRENCY_SELECT_OPTIONS = CURRENCIES.map(c => ({
  value: c.code,
  label: `${c.flag} ${c.code}`,
}));

export function getCurrency(code: string): CurrencyOption {
  return CURRENCIES.find(c => c.code === code) ?? CURRENCIES[0];
}
